/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {postPlaidBankLinking} from '../api'

export const useMutationPostPlaidBankLinking = createReactQueryMutationHook('postPlaidBankLinking', postPlaidBankLinking)
